import React from 'react';
import { aimieLogoUrl, camhLogoUrl, uoftLogoUrl } from '../../assets/assetPaths';
import './GuestAccessScreen.css';


const COPY = {
  disabled: {
    title: 'Guest access is currently closed',
    body: 'The AIMIE conference demo is not accepting new guest sessions right now.',
  },
  expired: {
    title: 'Your guest session has ended',
    body: 'This browser has reached the one-hour conference demo limit.',
  },
  revoked: {
    title: 'Your guest session has ended',
    body: 'Guest access for this browser is no longer active.',
  },
  unavailable: {
    title: 'We could not open the demo',
    body: 'AIMIE could not prepare your guest session. Please try again in a moment.',
  },
  loading: {
    title: 'Preparing your AIMIE session',
    body: 'We are opening one hour of guest access on this browser.',
  },
};


function GuestAccessScreen({ status = 'loading', onSignIn }) {
  const copy = COPY[status] || COPY.unavailable;

  return (
    <div className="guest-access-screen">
      <header className="guest-access-header">
        <span className="guest-access-brand">AIMIE</span>
        {status !== 'loading' && (
          <button type="button" className="guest-access-sign-in" onClick={onSignIn}>
            Sign in / sign up
          </button>
        )}
      </header>

      <main className="guest-access-main">
        <section className={`guest-access-content guest-access-content--${status}`} aria-live="polite">
          <div className="guest-access-portrait" aria-hidden="true">
            <img src={aimieLogoUrl} alt="" />
          </div>
          <div className="guest-access-copy">
            <p className="guest-access-eyebrow">AIMIE conference demo</p>
            <h1>{copy.title}</h1>
            <p className="guest-access-description">{copy.body}</p>

            {status === 'loading' && (
              <div className="guest-access-progress" role="status" aria-label="Preparing guest access">
                <span />
                <span />
                <span />
              </div>
            )}

            {status !== 'loading' && (
              <div className="guest-access-actions">
                <button type="button" className="guest-access-secondary" onClick={onSignIn}>
                  Continue with an account
                </button>
              </div>
            )}
          </div>
        </section>
      </main>

      <footer className="guest-access-footer" aria-label="AIMIE research partners">
        <img src={uoftLogoUrl} alt="University of Toronto" className="guest-access-partner guest-access-partner--uoft" />
        <span aria-hidden="true" />
        <img src={camhLogoUrl} alt="CAMH" className="guest-access-partner guest-access-partner--camh" />
      </footer>
    </div>
  );
}

export default GuestAccessScreen;
